module.exports = __webpack_public_path__ + "img/revolving_hearts.a62fa20c.gif";